<template>
  <v-container fluid>
    <v-card>
      <v-card-title>
        Formulario de inscripcion <v-spacer></v-spacer>
        <v-btn small @click="$router.back()" color="info" rounded outlined> <v-icon>mdi-arrow-left-bold</v-icon> Volver Atras</v-btn>
      </v-card-title>
      <v-card-subtitle class="pb-0">
        <span class="glyphicon glyphicon-exclamation-sign"></span> Los campos con un asterisco <span class="text-danger">*</span> son obligatorios
      </v-card-subtitle>

      <v-card-text>
        <v-row>
          <div>
            <form class="xcard" @submit.prevent="validarCampos" style="margin-top: 0" novalidate>
              <p class="text-primary"><b>Datos de Inscripcion</b></p>
              <div class="row" style="margin-top: 0; margin-bottom: 0; margin-left: 0px; margin-right: 0px; background: #ececec">
                <div class="col-sm-10">
                  <BuscarEstudiante
                    :model="newEstudiante"
                    :default="inscripcion.idestudiante"
                    :inscripcion="inscripcion"
                    :class="{ 'has-error': validation.hasError('inscripcion.idestudiante') }"
                  />
                  <b class="text-danger"><small>* Seleccione un estudiante para la inscripcion (Si no existe use el boton para registrarlo)</small></b>
                  <v-spacer></v-spacer>
                  <v-btn
                    rounded
                    small
                    outlined
                    color="warning"
                    data-toggle="collapse"
                    data-target="#collapseExample"
                    aria-expanded="false"
                    aria-controls="collapseExample"
                  >
                    Crear Nuevo Estudiante <v-icon>mdi-account-plus</v-icon>
                  </v-btn>
                  <div class="error" v-if="validation.hasError('inscripcion.idestudiante')">
                    {{ validation.firstError('inscripcion.idestudiante') }}
                  </div>
                </div>
              </div>
              <br />

              <RegistroEstudiante :inscripcion="inscripcion" />

              <div class="alert alert-success alert-dismissible" role="alert">
                <p><small>Detalles del programa</small></p>
                <p>
                  <small> <b>Matricula:</b> {{ programa.monto_matricula }} Bs. </small>
                </p>
                <p>
                  <small> <b>Colegiatura:</b> {{ programa.monto_colegiatura }} Bs. </small>
                </p>
                <p>
                  <small> <b>Certificacion:</b> {{ programa.monto_certificacion }} Bs. </small>
                </p>
              </div>

              <div class="row">
                <div class="col-sm-6">
                  <input :value="getNomProgram()" :disabled="true" type="text" class="form-control" placeholder="Programa" />
                  <small> <span class="text-danger">*</span> Programa (para cambiar regrese a programas y seleccione otro programa)</small>
                </div>
                <div class="col-sm-6">
                  <Usuarios :current="true" :model="inscripcion" :class="{ 'has-error': validation.hasError('inscripcion.idusuario') }" />
                  <small> <span class="text-danger">*</span> Asesor de la inscripcion</small>
                  <div class="error" v-if="validation.hasError('inscripcion.idusuario')">{{ validation.firstError('inscripcion.idusuario') }}</div>
                </div>
              </div>
              <br />
              <div class="row">
                <div class="col-sm-3" :class="{ 'has-error': validation.hasError('inscripcion.certificacion.monto') }">
                  <input v-model="inscripcion.certificacion.monto" type="text" class="form-control" placeholder="Monto Certificacion" />
                  <small> <span class="text-danger">*</span> Monto Certificacion</small>
                  <div class="error" v-if="validation.hasError('inscripcion.certificacion.monto')">
                    {{ validation.firstError('inscripcion.certificacion.monto') }}
                  </div>
                </div>
                <div class="col-sm-3" :class="{ 'has-error': validation.hasError('inscripcion.matricula.monto') }">
                  <input v-model="inscripcion.matricula.monto" type="text" class="form-control" placeholder="Monto matricula" />
                  <small> <span class="text-danger">*</span> Monto matricula</small>
                  <div class="error" v-if="validation.hasError('inscripcion.matricula.monto')">
                    {{ validation.firstError('inscripcion.matricula.monto') }}
                  </div>
                </div>
                <div class="col-sm-3" :class="{ 'has-error': validation.hasError('inscripcion.monto.monto_colegiatura') }">
                  <input v-model="inscripcion.monto.monto_colegiatura" type="text" class="form-control" placeholder="Monto Colegiatura" />
                  <small> <span class="text-danger">*</span> Monto Colegiatura</small>
                  <div class="error" v-if="validation.hasError('inscripcion.monto.monto_colegiatura')">
                    {{ validation.firstError('inscripcion.monto.monto_colegiatura') }}
                  </div>
                </div>
                <div class="col-sm-2" :class="{ 'has-error': validation.hasError('inscripcion.monto.cuotas') }">
                  <input v-model="inscripcion.monto.cuotas" type="text" class="form-control" placeholder="Cuotas" />
                  <small>Cantidad Cuotas (dejar vacio para pre-inscripción)</small>
                  <div class="error" v-if="validation.hasError('inscripcion.monto.cuotas')">
                    {{ validation.firstError('inscripcion.monto.cuotas') }}
                  </div>
                </div>
              </div>
              <br />
              <div class="row">
                <div class="col-sm-3"></div>
                <div class="col-sm-3" :class="{ 'has-error': validation.hasError('inscripcion.tipopago') }">
                  <input v-model="inscripcion.tipopago" type="radio" name="tpago" class="radio radio-inline" value="true" /> Credito
                  <input v-model="inscripcion.tipopago" type="radio" name="tpago" class="radio radio-inline" value="false" /> Contado
                  <small>
                    <br />
                    <span class="text-danger">*</span> Forma de pago
                  </small>
                  <div class="error" v-if="validation.hasError('inscripcion.tipopago')">{{ validation.firstError('inscripcion.tipopago') }}</div>
                </div>
                <div class="col-sm-3" title="Dejar vacio si es Pre Inscripcion">
                  <Fecha :model="inscripcion.matricula" :default="programa.fecha_inicio" />
                  <small>Fecha pago de matricula</small>
                </div>
                <div class="col-sm-3" title="Dejar vacio si es Pre Inscripcion">
                  <Fecha :model="inscripcion.certificacion" :default="programa.fecha_fin" />
                  <small>Fecha prevista pago de certificacion</small>
                </div>
              </div>
              <br />
              <div class="row">
                <div class="col-sm-6" :class="{ 'has-error': validation.hasError('inscripcion.observaciones') }">
                  <textarea v-model="inscripcion.observaciones" type="text" rows="6" class="form-control" placeholder="Observaciones"></textarea>
                  <small>Observaciones</small>
                </div>
                <div class="error" v-if="validation.hasError('inscripcion.observaciones')">
                  {{ validation.firstError('inscripcion.observaciones') }}
                </div>
                <div class="col-sm-6">
                  <button v-if="!preinscribir" type="button" class="btn btn-link" data-toggle="modal" data-target="#planPagos">
                    <span class="glyphicon glyphicon-calendar"></span> Ver el plan de pagos
                  </button>
                  <PlanPagos :cuotas="cuotas" :cole="inscripcion.monto.monto_colegiatura" :cuotas_validas="cuotas_validas" />
                </div>
              </div>

              <Alertas ref="alertar" />
              <p class="text-center">{{ msg }}</p>

              <button class="btn btn-link" type="button" @click="xgenerarContrato()" title="Crear pdf para imprimir">
                <span class="glyphicon glyphicon-print"></span> Generar Contrato
              </button>

              <p v-if="!preinscribir" class="text-center text-success">
                <small> <b>NOTA:</b> Para preinscribir solo debe eliminar la cantidad de cuotas</small>
              </p>
              <button
                v-show="cuotas_validas.valido"
                :disabled="!activo"
                title="Asegurese de haber llenado correctamente los datos."
                type="submit"
                class="btn btn-sm btn-azul center-block"
                v-bind="{ 'data-toggle': datosvalidos ? 'modal' : '', 'data-target': '#modal-confirmar' }"
              >
                <span class="glyphicon glyphicon-ok"></span> {{ getNomBtn() }}
              </button>

              <p v-show="!cuotas_validas.valido" class="text-center text-danger"><b>AVISO:</b> El plan de cuotas no coincide con el monto de la colegiatura.</p>

              <button v-if="idNewInscripcion > 0 && $store.state.deleteInscripcion" type="button" class="btn btn-sm btn-rojo" @click="preEliminarInscripcion()">
                <span class="t glyphicon glyphicon-trash"></span> Eliminar inscripcion
              </button>
            </form>

            <div v-if="matriculaCreada.id > 0" class="row">
              <div class="col-sm-6">
                <div v-if="matriculaCreada.monto > 0">
                  <PagarMatricula :id="matriculaCreada.id" :monto_total="matriculaCreada.monto" />
                </div>
              </div>
              <div class="col-sm-6">
                <PagarCuota :cuotas_por_pagar="cuotas_por_pagar" />
              </div>
            </div>
            <notifications group="auth" position="bottom right" />

            <v-btn small class="mx-4" @click="$router.back()" color="info" rounded outlined> <v-icon>mdi-arrow-left-bold</v-icon> Volver Atras</v-btn>
          </div>
        </v-row>
      </v-card-text>
    </v-card>
  </v-container>
</template>
<script>
import Usuarios from '@/components/AUsuariosActivos.vue';
import BuscarEstudiante from '@/components/ABuscarEstudiante.vue';
import Alertas from '@/components/AAlertas.vue';
import RegistroEstudiante from './RegNewStudent.vue';
import Fecha from '@/components/AFecha.vue';
import PlanPagos from '@/components/AVer-cuotas.vue';
import PagarMatricula from '@/components/APagar-matricula.vue';
import PagarCuota from '@/components/APagar-cuota.vue';
import { generarContrato } from '@/components/generar-contrato.js';
import { Validator } from 'simple-vue-validator';
import gql from 'graphql-tag';
import { parseJsonError, datFaltantes, isNullObject, error } from '@/components/Utils.js';
// import { mapState } from 'vuex';

export default {
  data() {
    return {
      activo: true,
      preinscribir: true,
      datosvalidos: true,
      msg: '',
      modelinscrito: {},
      idNewInscripcion: 0,
      programa: {},
      cuotas_validas: { valido: true },
      atras: 'programas',
      newEstudiante: {
        iddepartamento: null,
        idciudad: null,
        idprofesion: null,
        iduniversidad: null,
        idempresa: null,
        idgrado: null,
      },
      inscripcion: {
        idestudiante: null,
        tipopago: false,
        idprograma: null,
        idusuario: null,
        matricula: { monto: -1, fecha: '' },
        certificacion: { monto: -1, fecha: '' },
        monto: { monto_colegiatura: -1, cuotas: null, fecha_ins: null },
        observaciones: null,
      },
      matriculaCreada: { id: -1 },
      cuotas_por_pagar: [],
      cuotas: [],
    };
  },
  components: {
    // Departamentos,
    // Ciudades,
    // Universidades,
    // Profesiones,
    // Grados,
    // Empresas,
    Usuarios,
    BuscarEstudiante,
    Alertas,
    RegistroEstudiante,
    Fecha,
    PlanPagos,
    PagarMatricula,
    PagarCuota,
  },
  validators: {
    'inscripcion.idprograma'(value) {
      return Validator.value(value).required();
    },
    'inscripcion.idestudiante'(value) {
      return Validator.value(value).required();
    },
    'inscripcion.idusuario'(value) {
      return Validator.value(value).required();
    },
    'inscripcion.tipopago'(value) {
      return Validator.value(value).required();
    },
    'inscripcion.matricula.monto'(value) {
      return Validator.value(value).required().digit();
    },
    'inscripcion.monto.monto_colegiatura'(value) {
      return Validator.value(value).required().digit();
    },
    'inscripcion.certificacion.monto'(value) {
      return Validator.value(value).required().digit();
    },
    'inscripcion.monto.cuotas'(value) {
      return Validator.value(value).digit().greaterThan(0);
    },
    'inscripcion.observaciones'(value) {
      return Validator.value(value).minLength(0).regex('^[A-ZÁÉÍÓÚÑa-zñáéíóú][A-ZÁÉÍÓÚÑa-zñáéíóú]+(\\s[A-ZÁÉÍÓÚÑa-zñáéíóú][A-ZÁÉÍÓÚÑa-zñáéíóú]+)*$');
    },
  },
  watch: {
    'inscripcion.monto.cuotas': function () {
      this.lisCuotas();
    },
    inscripcion: {
      deep: true,
      handler(a) {
        if (a == null) return;
        this.preinscribir = true;
        this.msg = '';
        this.$refs.alertar.reset();
        this.datosvalidos = false;
        window.sessionStorage.setItem('xinscripcion', JSON.stringify(this.inscripcion));
        /*if( this.programa && this.inscripcion.matricula ){
                    if( this.inscripcion.matricula.monto == this.programa.monto_matricula ) this.inscripcion.tipopago = false;
                    else this.inscripcion.tipopago = true;
                }*/
        this.lisCuotas();

        if (a.monto.monto_colegiatura != null && a.monto.cuotas != null) {
          var mensualidad = Math.trunc(Math.ceil(a.monto.monto_colegiatura / a.monto.cuotas));
          if (!isNaN(mensualidad) && isFinite(mensualidad)) {
            var cole = parseInt(a.monto.monto_colegiatura);
            var cuos = [];
            var nro = 1;
            var fecha = new Date();
            var srtf = '';
            while (cole - mensualidad > 0) {
              var ani = fecha.getFullYear();
              var mes = fecha.getMonth() + 1;
              var dia = fecha.getDate();
              if (mes < 10) mes = '0' + mes;
              if (dia < 10) dia = '0' + dia;
              cole = cole - mensualidad;
              srtf = ani + '-' + mes + '-' + dia;
              fecha.setMonth(mes);
              fecha.setDate(15);
              cuos.push({ monto: mensualidad, nro_cuota: nro, fecha: srtf });
              nro += 1;
            }
            if (cole > 0) {
              ani = fecha.getFullYear();
              mes = fecha.getMonth() + 1;
              dia = fecha.getDate();
              if (mes < 10) mes = '0' + mes;
              if (dia < 10) dia = '0' + dia;
              srtf = ani + '-' + mes + '-' + dia;
              fecha.setMonth(mes);
              fecha.setDate(15);
              cuos.push({ monto: cole, nro_cuota: nro, fecha: srtf });
            }
            this.cuotas = cuos;
            window.sessionStorage.setItem('xcuotas', JSON.stringify(this.cuotas));
            this.preinscribir = false;
          }
        }
      },
    },
  },
  // computed: { ...mapState({ programa: (state) => state.programa.value }) },
  methods: {
    lisCuotas() {
      if (this.inscripcion.monto.cuotas > 2) this.inscripcion.tipopago = true;
      else this.inscripcion.tipopago = false;
    },
    xgenerarContrato() {
      if (this.inscripcion.idestudiante == null) {
        this.$notify(error('Contrato', 'Seleccione un Estudiante.'));
        return;
      }
      var obj = window.Object.assign({}, this.inscripcion);
      obj.matricula.saldo = obj.matricula.monto;
      generarContrato(
        this.programa,
        this.cuotas,
        this.inscripcion.idestudiante,
        { monto_colegiatura: obj.monto.monto_colegiatura, monto_matricula: obj.matricula.monto },
        obj
      );
    },
    getNomBtn() {
      if (this.preinscribir) return 'Preinscribir';
      return 'Inscribir';
    },
    getNomProgram() {
      if (this.programa == null) return '';
      if (this.programa.postgrado == null) return '';
      return this.programa.postgrado.categoria.nombre + ' - ' + this.programa.postgrado.nombre;
    },
    validarCampos() {
      if (!this.activo) return;
      this.activo = true;
      var vue = this;
      this.$validate().then((success) => {
        var obj = window.Object.assign({}, this.inscripcion);
        if (success) {
          vue.datosvalidos = true;
          obj.idestudiante = obj.idestudiante.id;
          obj.idasesor = obj.idusuario.id;
          obj.matricula.monto = parseInt(obj.matricula.monto);
          obj.certificacion.monto = parseInt(obj.certificacion.monto);
          obj.monto.monto_colegiatura = parseInt(obj.monto.monto_colegiatura);
          if (obj.tipopago || obj.tipopago == 'true') obj.tipopago = true;
          else obj.tipopago = false;

          if (obj.matricula.monto > vue.programa.monto_matricula) {
            vue.$notify(error('Matricula', 'La matricula no puede ser mayor a la establecida en el programa.'));
            return;
          }

          delete obj.idusuario;
          this.$store.state.obj = obj;
          this.$store.dispatch('quitarNulos');
          this.$refs.alertar.cargando();
          delete obj.monto;
          if (this.preinscribir) {
            obj.monto_matricula = this.inscripcion.matricula.monto;
            obj.monto_colegiatura = this.inscripcion.monto.monto_colegiatura;
            obj.monto_certificacion = this.inscripcion.certificacion.monto;
            delete obj.matricula;
            delete obj.certificacion;
            delete obj.tipopago;
            window.sessionStorage.setItem('obj', JSON.stringify(obj));
            this.$dialog
              .confirm(this.$store.state.alertmsg)
              .then(function () {
                vue.xpreinscribir(obj);
              })
              .catch(function () {
                vue.$refs.alertar.reset();
              });
          } else {
            obj.cuotas = this.cuotas;
            if (obj.matricula.fecha == '' || obj.certificacion.fecha == '') {
              this.$refs.alertar.invalido();
              this.$notify(datFaltantes('ERROR: ingrese las fechas de pago de matricula y certificacion'));
            } else {
              delete obj.matricula.saldo;
              window.sessionStorage.setItem('obj', JSON.stringify(obj));
              window.sessionStorage.setItem('objestudiante', JSON.stringify(obj.idestudiante));
              this.$dialog
                .confirm(this.$store.state.alertmsg)
                .then(function () {
                  vue.inscribir(obj);
                })
                .catch(function () {
                  vue.$refs.alertar.reset();
                });
            }
          }
        } else {
          vue.datosvalidos = false;
          this.$refs.alertar.invalido();
        }
      });
    },
    confirmado() {},
    xpreinscribir(obj) {
      obj = JSON.parse(window.sessionStorage.getItem('obj'));
      var vue = this;
      var sql = gql`mutation{ createPreInscripcion(input:${window.stringifyObject(
        obj
      )}){ok,errors{message},inscripcion{matricula{id,monto,idinscripcion,puede_pagar,saldo}}} }`;
      vue.msg = '';

      this.$apollo
        .mutate({
          mutation: sql,
        })
        .then((data) => {
          if (data.data.createPreInscripcion.ok) {
            vue.$refs.alertar.success();
            window.sessionStorage.setItem('xprograma', null); // TODO: vacia programa nullo
            window.sessionStorage.setItem('xinscripcion', null);
            window.firebaseNotificacion('Nuevo Participante');
          } else {
            var errores = JSON.stringify(data.data.createPreInscripcion.errors);
            var obj = JSON.parse(errores);
            var vals = '';
            obj.forEach(function (k) {
              vals += Object.values(k) + '-\n\t';
            });
            //vue.msg = vals;
            vue.msg = '';
            vue.activo = true;
            vue.$refs.alertar.invalido(vals);
          }
        })
        .catch((error) => {
          vue.$refs.alertar.invalido();
          this.activo = true;
          window.console.error(JSON.stringify(error));
          //vue.msg = error;

          this.$notify(parseJsonError(error));
        });
    },
    inscribir(obj) {
      obj = JSON.parse(window.sessionStorage.getItem('obj'));
      var vue = this;
      var sql = gql`mutation{ createInscripcion(input:${window.stringifyObject(obj)}){ ok,errors{message},inscripcion{id,asesor{nombres,pri_apellido,seg_apellido},estudiante{id,nombres,telefono1,pri_apellido,seg_apellido,num_doc,departamento{extension}},cuotas_por_pagar{id,monto,nro_cuota,saldo,fecha,puede_pagar}},inscripcion{matricula{id,monto,idinscripcion,puede_pagar,saldo}}} }`;
      vue.msg = '';
      // window.console.log(sql);
      this.$apollo
        .mutate({
          mutation: sql,
        })
        .then((data) => {
          if (data.data.createInscripcion.ok) {
            vue.$refs.alertar.success();
            window.sessionStorage.setItem('nueva_inscripcion', JSON.stringify(data.data.createInscripcion.inscripcion));
            vue.matriculaCreada = data.data.createInscripcion.inscripcion.matricula;
            vue.cuotas_por_pagar = data.data.createInscripcion.inscripcion.cuotas_por_pagar;
            vue.idNewInscripcion = data.data.createInscripcion.inscripcion.id;
            window.sessionStorage.setItem('xprograma', null); // TODO: vacia programa nullo
            window.sessionStorage.setItem('xinscripcion', null);
            window.firebaseNotificacion('Nuevo Participante');
          } else {
            var errores = JSON.stringify(data.data.createInscripcion.errors);
            var obj = JSON.parse(errores);
            var vals = '';
            obj.forEach(function (k) {
              vals += Object.values(k) + '-\n\t';
            });
            //vue.msg = vals;
            vue.msg = '';
            vue.activo = true;
            vue.$refs.alertar.invalido(vals);
          }
        })
        .catch((error) => {
          vue.$refs.alertar.invalido();
          this.activo = true;
          window.console.error(error);
          //vue.msg = error;
          this.$notify(parseJsonError(error));
        });
    },
    preEliminarInscripcion() {
      var vue = this;
      this.$dialog
        .confirm(
          'Confirmacion<br><br>Esta accion es irreersible, solo se puede eliminar una inscripcion cuando no haya cancelado ningun pago.<br><small>ID: ' +
            this.idNewInscripcion +
            ';' +
            this.programa.id +
            '</small>'
        )
        .then(function () {
          vue.eliminarInscripcion();
        })
        .catch(function (e) {
          window.console.error(e);
        });
    },
    eliminarInscripcion() {
      var vue = this;
      this.$refs.alertar.cargando('Eliminando inscripcion...');
      var sql = gql`mutation{ deleteInscripcion(input:{ id:${this.idNewInscripcion},idprograma: ${this.programa.id} }){ok,errors{message}} }`;
      this.idNewInscripcion = 0;

      this.$apollo
        .mutate({
          mutation: sql,
        })
        .then((data) => {
          if (data.data.deleteInscripcion.ok) {
            vue.$refs.alertar.success('Inscripcion eliminada.');
            vue.idNewInscripcion = 0;
            vue.matriculaCreada.id = 0;
          } else {
            var errores = JSON.stringify(data.data.deleteInscripcion.errors);
            var obj = JSON.parse(errores);
            var vals = '';
            obj.forEach(function (k) {
              vals += Object.values(k) + '-\n\t';
            });
            vue.msg = '';
            vue.activo = true;
            vue.$refs.alertar.invalido(vals);
          }
        })
        .catch((error) => {
          this.activo = true;
          window.console.error(error);
          vue.msg = error;
          vue.$refs.alertar.invalido();
        });
    },
  },
  mounted() {
    if (sessionStorage.xprograma != undefined) {
      // tambien se usa en AexcelInscribirProgramas.vue
      var ob1 = JSON.parse(sessionStorage.xprograma);
      if (!isNullObject(ob1)) this.programa = ob1;
    }
    if (sessionStorage.xinscripcion != undefined) {
      var ob = JSON.parse(sessionStorage.xinscripcion);
      if (!isNullObject(ob)) this.inscripcion = ob;
    }
    if (isNullObject(ob1)) {
      this.$notify(error('Error', 'No existe el programa seleccionado, vuelva atras y seleccione uno.'));
    }
    if (this.programa != null) {
      this.inscripcion.idestudiante = null;
      this.inscripcion.idprograma = this.programa.id;
      this.inscripcion.matricula.monto = this.programa.monto_matricula;
      this.inscripcion.certificacion.monto = this.programa.monto_certificacion;
      this.inscripcion.monto.monto_colegiatura = this.programa.monto_colegiatura;
      this.inscripcion.monto.cuotas = this.programa.cuotas;
      this.inscripcion.monto.fecha_ins = this.programa.fecha_inicio;
      var vue = this;
      setTimeout(function () {
        var ff = vue.programa.fecha_fin;
        var fi = vue.programa.fecha_inicio;
        vue.inscripcion.certificacion.fecha = ff;
        vue.inscripcion.matricula.fecha = fi;
      }, 3000);
    }
    var ats = window.sessionStorage.route_ins;
    if (ats) this.atras = ats;

    this.lisCuotas();
  },
};
</script>

<style>
</style>